import { render } from "./FAQQuestions.vue?vue&type=template&id=45f004f4&scoped=true"
import script from "./FAQQuestions.vue?vue&type=script&lang=js"
export * from "./FAQQuestions.vue?vue&type=script&lang=js"

import "./FAQQuestions.vue?vue&type=style&index=0&id=45f004f4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45f004f4"]])

export default __exports__